import { useRef, useState, useCallback, useEffect } from "react";
import { useRouter } from "next/router";
import isOuterArea from "@/lib/isOuterArea";

export function useDropdown({ mouseOver }) {
  const router = useRouter();
  const buttonRef = useRef();
  const contentRef = useRef();
  const [show, setShow] = useState(false);
  const [hovered, setHovered] = useState(false);

  const handleClick = useCallback(() => setShow(!show), [show]);
  const handleMouseOver = useCallback(() => setHovered(true), []);
  const handleMouseLeave = useCallback(() => setHovered(false), []);

  const listener = useCallback((e) => {
    if (buttonRef.current && contentRef.current) {
      if (
        isOuterArea(buttonRef.current, e) &&
        isOuterArea(contentRef.current, e)
      ) {
        setShow(false);
      }
    }
  }, []);

  useEffect(() => {
    const routeChangeHandler = () => setShow(false);
    if (typeof document !== "undefined") {
      router.events.on("routeChangeStart", routeChangeHandler);
      router.events.on("hashChangeStart", routeChangeHandler);
      document.addEventListener("click", listener, false);
    }
    return () => {
      if (typeof document !== "undefined") {
        router.events.off("routeChangeStart", routeChangeHandler);
        router.events.off("hashChangeStart", routeChangeHandler);
        document.removeEventListener("click", listener, false);
      }
    };
  }, []);

  useEffect(() => {
    let timeoutId;
    if (mouseOver) {
      timeoutId = setTimeout(() => {
        setShow(hovered);
      }, 300);
    }
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [mouseOver, hovered]);

  return {
    buttonRef,
    contentRef,
    show,
    setShow,
    hovered,
    listeners: { handleClick, handleMouseOver, handleMouseLeave },
  };
}
